import { render } from "./RegionZKO.vue?vue&type=template&id=20c6ce79&ts=true"
import script from "./RegionZKO.vue?vue&type=script&lang=ts"
export * from "./RegionZKO.vue?vue&type=script&lang=ts"

import "./RegionZKO.vue?vue&type=style&index=0&id=20c6ce79&lang=scss"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__